// Footer.js
import React from 'react';
import { Box, Container, Grid, IconButton, Typography, Link } from '@mui/material';
import { Facebook, Twitter, Instagram } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 3,
        mt: '50px',
        
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Company Name</Typography>
            <Typography variant="body2" color="inherit">
              © 2024 All Rights Reserved.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Quick Links</Typography>
            <Link href="/home" color="inherit" underline="none">Home</Link><br />
            <Link href="/about-us" color="inherit" underline="none">About</Link><br />
            <Link href="/contact-us" color="inherit" underline="none">Contact</Link>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Follow Us</Typography>
            <IconButton
              color="inherit"
              href="https://facebook.com"
              aria-label="Facebook"
            >
              <Facebook />
            </IconButton>
            <IconButton
              color="inherit"
              href="https://twitter.com"
              aria-label="Twitter"
            >
              <Twitter />
            </IconButton>
            <IconButton
              color="inherit"
              href="https://instagram.com"
              aria-label="Instagram"
            >
              <Instagram />
            </IconButton>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
